import Vue from 'vue'
import Router from 'vue-router'
import { environment } from '@/environments/environment';

import { routes } from './routes'
import IdentityService from '@/service/identity';
Vue.use(Router)

const identity = new IdentityService();
const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach(
  (to, from, next) => {
    if (to.matched.some(record => record.meta.title)) {
      document.title = to.meta.title;
    }
    if (to.matched.some(record => record.meta.requiresAuth) &&!identity.isAuthenticated(to)) {
      window.location.href = `${environment.jdyUrl}/login.html?redirect=/wezhanconfig`;
      
      return;
    }
    if (to.matched.some(record => record.meta.requiresRole) && !identity.checkRole(to.meta.requiresRole)) {
      next({
        path: '/norole.html',
        query: { redirect: to.fullPath }
      });
      return;
    }
    next();
  });
export default router



// WEBPACK FOOTER //
// ./src/router/index.js